var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6242_5967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.14391 0 3.36219 0.737953 2.05078 2.05023C0.738022 3.36304 0.000363639 5.14345 0 7C0 8.85577 0.738281 10.6375 2.05078 11.9498C3.36219 13.262 5.14391 14 7 14C8.85609 14 10.6378 13.262 11.9492 11.9498C13.2617 10.6375 14 8.85577 14 7C14 5.14423 13.2617 3.36252 11.9492 2.05023C10.6378 0.737953 8.85609 0 7 0Z",
    fill: "url(#paint0_linear_6242_5967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16849 6.927C5.20943 6.038 6.57006 5.45186 7.25037 5.16869C9.19506 4.36008 9.59865 4.21964 9.86224 4.21489C9.92021 4.21396 10.0493 4.22828 10.1335 4.29637C10.2035 4.35379 10.2232 4.43145 10.233 4.48597C10.2418 4.54044 10.2538 4.66458 10.244 4.76149C10.139 5.86836 9.68287 8.55439 9.45099 9.79416C9.35365 10.3187 9.16006 10.4946 8.97303 10.5118C8.56615 10.5492 8.25771 10.2431 7.86396 9.98513C7.24818 9.5812 6.90037 9.32986 6.30209 8.93578C5.61084 8.48035 6.05928 8.22999 6.45303 7.82092C6.55584 7.71385 8.3474 6.08471 8.38131 5.93694C8.38568 5.91846 8.39006 5.84955 8.34849 5.81324C8.30803 5.77681 8.24787 5.78928 8.20412 5.79913C8.14178 5.81313 7.15849 6.46369 5.25099 7.75071C4.97209 7.94255 4.71943 8.03606 4.49193 8.03114C4.24256 8.02578 3.76131 7.88983 3.40365 7.77367C2.96615 7.63116 2.61724 7.5558 2.64787 7.31375C2.66318 7.18775 2.83709 7.0588 3.16849 6.927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6242_5967",
    x1: 700,
    y1: 0,
    x2: 700,
    y2: 1400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6242_5967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.9c28eb6f6ae133baafbef8e222e4f935.svg";
export { ForwardRef as ReactComponent };